import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchCasesApi } from '../../api/cases-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  cases: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchCasesListing = createAsyncThunk('cases/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchCasesApi(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const CasesSlice = createSlice({
  name: 'cases',
  initialState,
  reducers: {
    setCasesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setCasesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCasesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchCasesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.cases = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchCasesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setCasesActiveColumn, setCasesLoading } = CasesSlice.actions;
export default CasesSlice.reducer;
